module.exports = {
    // basic
    'output-format': 'formato de salida',
    'an-output-format': 'un formato de salida',
    'new-entry-type': 'nuevo tipo de entrada',
    'months-previous': 'meses anteriores',
    'date-ranges': 'rangos de fechas',
    'schedule': 'calendario',
    'export': 'exportación',
    'exports': 'exportaciones',
    'prod-data-export': 'exportación de datos de producción',
    'distribution': 'distribucion',
    'prod-data-distribution': 'distribución de datos de producción',
    'prod-data-access-review': 'revisión de acceso a datos de producción',
    'column': 'column',
    'new-company': 'nuevo compañía',
    'current-month-inclusive': 'mes actual inclusive',
    'allowed-data-columns': 'columnas de datos permitidos',
    'column-name': 'nombre de columna',
    'well-property': 'bien de propiedad',
    'time-of-data-delivery': 'tiempo de entrega de datos',
    'days-of-data-delivery': 'días de entrega de datos',

    // raw
    'prod-delete-saved-export': '¿Está seguro de que desea eliminar esta exportación guardada?',
    'prod-export-no-data': 'No se encontraron datos que coincidan con ese criterio de búsqueda.',
    'prod-data-export-columns-help': `Para cada una de las columnas especificadas en el formato de salida que ha seleccionado, debe seleccionar qué datos se mostrarán. Cualquier columna sin selección de <b>Fuente</b> aparecerá vacía en el archivo de salida.`,
    'prod-data-export-company-help': `<b>Compañía</b> selecciona qué datos de la compañía desea incluir en la salida.`,
    'prod-data-export-limits-help': 'Puede limitar los datos a activos, plataformas o pozos específicos, a continuación.',
    'prod-data-export-entry-type-help': `
        <ul>
            <li>
                <b>Tipo de entrada</b> selecciona qué Tipo de entrada desea incluir en la salida.
            </li>
            <li>
                <b>La asignación de columnas</b> controla cómo se asigna cada propiedad de datos desde el formato de origen al formato de salida seleccionado.
            </li>
        </ul>
    `,
    'search-name-required': 'Introduzca un nombre de búsqueda.',
    'days-value-required': 'Ingrese el valor de los días.',
    'months-value-required': 'Ingrese el valor de los meses.',
    'date-ranges-help': 'Los controles <b>Intervalos de fechas</b> establecen el intervalo de datos incluidos en la salida.',
    'prod-data-export-file-name-help': `
        <b>Nombre de archivo</b> le permite especificar el nombre del archivo que recibirá siempre que descargue datos después de cargar esta exportación guardada, o cuando recibir los datos de esta exportación en un horario.
    `,
    'prod-output-format-help': `
        Aquí puede definir exactamente qué columnas se incluyen en los datos que descarga (o recibe de forma programada). Para cada
        columna, puede ingresar su propio <b>Nombre de columna</b>, o puede seleccionar una <b>Propiedad de pozo</b> existente (es decir, Compañía, Pad, Activo, etc.).<br />
        Si ingresa su propio <b>Nombre de columna</b>, podrá seleccionar qué datos van en esa columna en la página Exportación de datos de producción.<br />
        Si selecciona una <b>Propiedad de pozo</b>, los datos de esa columna se completarán automáticamente.
    `,
    'column-required': `Por favor ingrese al menos una columna.`,
    'format-name-required': `Introduzca un nombre de formato.`,
    'download-failed': 'Descarga fracasó.',

    // template
    'output-format-help': (words) => `
        <p>
            <b>Formato de salida</b> le permite seleccionar de <a href="#prodOutputFormat/user/${words[0]}">su lista de formatos de salida predefinidos</a> para controlar cómo desea que aparezcan los datos en el archivo CSV que descarga o programa para que se le entreguen.
        </p>
        <p>
            Si no define o selecciona un formato de salida, los datos estarán en su formato original.
        </p>
        <p>
            Si su criterio de búsqueda especifica varios tipos de entrada o empresas, y desea que aparezca en un solo archivo de salida, debe seleccionar un Formato de salida (así como un <b>Mapeo de columnas</b>, a continuación). De lo contrario, la salida será un archivo zip de varios archivos, cada uno de los cuales contiene los datos en su formato original.
        </p>
    `,
    'month-range-help': (words) => `La salida incluirá datos cargados entre el ${words[0]} y el ${words[1]}.`,
    'prod-data-export-time-zone-help': (words) => `La zona horaria predeterminada es CST. Si desea utilizar uno diferente, cambie la configuración de <b>Zona horaria</b> en la página <a href="#myAccount/${words[0]}">Mi cuenta</a>.`,
    'prodDataAccessReview for': 'es Production Data Access Review',
    'column-name-matches-built-in-property': (columnName) => `${columnName} coincide con el nombre de una propiedad integrada. Utilice otro nombre.`,
};
